/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-27T10:46:06+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-06T18:38:57+02:00
*/


import React, {Children, Component} from 'react';
import PropTypes from 'prop-types';
import {Field, Errors} from 'react-redux-form/src';
import MLabelInput from './../components/MLabelInput';
import MInputGroupRadioText from './../components/MInputGroupRadioText';
import MInputGroupRadioSelect from './../components/MInputGroupRadioSelect';
import AErrorInput from './../components/AErrorInput';
import MErrorGroupInput from './../components/MErrorGroupInput';
import shouldShowErrors from './shouldShowErrors';


/**
 * OInputFieldGroup - …
**/
class OInputFieldGroup extends Component {
  render() {
    const {
      children,
      model,
      component,
      dynamic,
      parser,
      defaultValue,
      disabled,
      validators,
      validateOn,
      asyncValidators,
      messages,
      showErrors,
      label,
      description,
      toolLabel,
      toolIcon,
      onPressTool,
      style,
      uniqueGroupId,
    } = this.props;

    const extraPaddingClass = (component === MInputGroupRadioText) ? 'extra-padding' : '';

    let groupName = model;

    if ( uniqueGroupId.length > 0 ) {
      groupName += '__' + uniqueGroupId;
    }

    return (
      <div className={`o-input-field o-input-field-group ${extraPaddingClass}`} style={style}>
        <MLabelInput
          label={label}
          description={description}
          toolLabel={toolLabel}
          toolIcon={toolIcon}
          onPressTool={onPressTool}
          disabled={disabled}
        />
        <Field
          model={model}
          dynamic={dynamic}
          defaultValue={defaultValue}
          component={component}
          validators={validators}
          validateOn={validateOn}
          asyncValidators={asyncValidators}
          parser={parser}
          controlProps={{
            disabled,
          }}
          groupName={groupName}
          mapProps={{
            error: (props) => shouldShowErrors(showErrors, props),
            checked: (props) => String(props.modelValue) === props.htmlValue,
            value: (props) => String(props.value),
            onChange: (props) => props.onChange,
            onFocus: (props) => props.onFocus,
            onBlur: (props) => props.onBlur,
            onKeyPress: (props) => props.onKeyPress,
            groupName: (props) => props.groupName,
          }}
        >
          {children}
        </Field>
        <Errors
          model={model}
          messages={messages}
          wrapper={MErrorGroupInput}
          component={AErrorInput}
          show={showErrors}
        />
      </div>
    );
  }
}

OInputFieldGroup.propTypes = {
  /**
     * some AInputRadioText
     * do not set the checked valu of them
     */
  children: PropTypes.any,
  /**
     * react-redux-form model
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/models.html
     */
  model: PropTypes.string.isRequired,
  /**
     * group component to use for the input-group
     */
  component: PropTypes.oneOf([
    MInputGroupRadioText,
    MInputGroupRadioSelect,
  ]).isRequired,
  /**
     * if the input-field is dynamic, means if its children change or not,
     * pass false to get better performance
     */
  dynamic: PropTypes.bool,
  /**
     * function which gets the value and parse it
     * see also: https://davidkpiano.github.io/react-redux-form/docs/api/Control.html#prop-parser
     */
  parser: PropTypes.func,
  /**
     * default value of the component
     */
  defaultValue: PropTypes.string,
  /**
     * disable the input
     */
  disabled: PropTypes.bool,
  /**
     * hash with validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validators: PropTypes.object,
  /**
     * when validation should be fired
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validateOn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  /**
     * hash with async validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  asyncValidators: PropTypes.object,
  /**
     * error messages for validatiors
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html#messages
     */
  messages: PropTypes.object,
  /**
     * when errors should be shown
     * function which gets passed the props of the form-model
     * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
     */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
  /**
     * label and children are the same
     */
  label: PropTypes.string,
  /**
     * description for the input
     */
  description: PropTypes.any,
  /**
     * label for the tool-button, like 'Help'
     */
  toolLabel: PropTypes.string,
  /**
     * icon for the tool button like 'question-sign'
     */
  toolIcon: PropTypes.string,
  /**
     * displays a tool button with icon and fires
     * whe it is pressed. useful to show extra help infos
     */
  onPressTool: PropTypes.func,
  /**
     * inline style for element
     */
  style: PropTypes.object,
  /**
     * uniqueGroupId : a suffix for the name of an controlled input
     */
  uniqueGroupId: PropTypes.string,
};
OInputFieldGroup.defaultProps = {
  validateOn: ['change', 'focus'],
  uniqueGroupId: '',
};
export default OInputFieldGroup;

